import { gql } from '@apollo/client';

export const GET_LANDING_PAGE = gql`
query GET_LANDINGDASHBOARD_NAME {
  getLandingDashboardPage {
    dashboardGroupId
  }
}
`;
